import styled, { css } from 'styled-components';

import { AvatarUploadVariant } from '.';
import { Error, FileRequirement } from './Message';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const variants: { [key in AvatarUploadVariant]: ReturnType<typeof css> } = {
  inline: css`
    ${FileRequirement},
    ${Error} {
      font-size: 14px;
      line-height: 25px;
      margin: 0 15px 0 0;

      br {
        display: block;
      }
    }

    ${Container} {
      flex-direction: row-reverse;
      align-items: flex-start;
    }
  `
};

export default styled.div<{ variant?: AvatarUploadVariant }>`
  display: flex;
  flex-direction: row;

  ${({ variant }) => variant && variants[variant]};
`;
